export default "__VITE_ASSET__m24g1lDt__"